export enum Lang {
  EN = 'en',
  PTBR = 'pt-BR',
  // ES = 'es',
}
